import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import I18n from "i18next";
import { useFormik } from "formik";
import * as yup from "yup";

import MzInput from "@markaaz/ui/MzInputControls";
import MzButton from "@markaaz/ui/MzButton";

const sx = {
  root: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    h1: {
      color: "darkBlue.c100",
      fontSize: "24px",
      fontWeight: "600",
      lineHeight: "36px"
    }
  },

  content: {
    display: "flex",
    flexDirection: "column",
    width: "325px",
    alignItems: "center",
    justifyContent: "center"
  },

  input: {
    margin: "10px 0"
  },

  title: {
    marginBottom: "40px"
  },

  button: {
    marginTop: "40px"
  }
};

export default function CreatePassword({ onSubmit }) {
  async function handleVerifyPassword(values) {
    await onSubmit(values.password);
    localStorage.clear();
  }

  return (
    <>
      <PasswordForm title="Verify your password" label="Password" onSubmit={handleVerifyPassword} />
    </>
  );
}

let validationSchema = yup.object({
  password: yup
    .string()
    .required("Password is required")
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/, I18n.t("authPages.passwordCriteria")),
  confirmPassword: yup
    .string()
    .required("Please re-enter your password")
    .oneOf([yup.ref("password"), null], "Passwords must match")
});

function PasswordForm({ title, btnText = "Submit", onSubmit }) {
  const initialValues = {
    password: ""
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async () => {
      await onSubmit(formik.values);
    },
    validationSchema,
    enableReinitialize: true,
    validateOnMount: true
  });

  return (
    <Box sx={sx.root}>
      <Box sx={sx.content} component="form">
        <Typography variant="h1" sx={sx.title}>
          {title}
        </Typography>
        <MzInput
          sx={sx.input}
          name="password"
          label="New Password"
          autoComplete="new-password"
          type="password"
          noBorder
          required
          fullWidth
          error={formik.touched.password && !!formik.errors.password}
          helperText={formik.touched.password && formik.errors.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        ></MzInput>
        <MzInput
          sx={sx.input}
          name="confirmPassword"
          label="Confirm New Password"
          autoComplete="new-password"
          type="password"
          noBorder
          fullWidth
          required
          error={formik.touched.confirmPassword && !!formik.errors.confirmPassword}
          helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        ></MzInput>

        <MzButton
          variant="contained"
          color="primary"
          sx={sx.button}
          size="large"
          disabled={!formik.isValid || formik.isSubmitting}
          loading={formik.isSubmitting}
          onClick={formik.handleSubmit}
        >
          {btnText}
        </MzButton>
      </Box>
    </Box>
  );
}
